module.exports = __webpack_public_path__ + "img/img_05.9bffd0fc.jpg";